export const LIGHT_THEME_DESIGN = {
  cardColor: '#fff',
  cardBorder: '1px solid #B2B2B2',
  cardBorderRadius: '4',
  inputTextColor: '#212121',
  placeHolderColor: '#B2B2B2',
  msgTextColor: '#B2B2B2',
  invalidMsgTextColor: '#FF5252',
  msgTextFont: "'Verdana'",
  inputBackgroundColor: '#FFF',
  inputBorderColor: {
    byDefault: '#B2B2B2',
    hover: '#B2B2B2',
    active: '#B2B2B2'
  },
  buttonIconColor: {
    refresh: '#4B4B4B',
    verify: '#9739C1',
    success: '#4CAF50',
    fail: '#FF5252',
    audio: '#4B4B4B',
    audiofocus: '#9739C1'
  }
}

export const MT_CAPTCHA_NAME = 'mtcahptcha'
export const H_CAPTCHA_NAME = 'hcaptcha'
